//C:\Users\Anish\xpr_survey\XPRSuvey-App\src\Utility\SurveyNavTabs.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { ListChecks, UserPlus, BarChart3, Share2, ArrowLeft } from "lucide-react";

const TABS = [
    { key: "questions", label: "Manage Questions", icon: ListChecks },
    { key: "assignToCompany", label: "Manage Company", icon: UserPlus },
     { key: "assign", label: "Manage Users", icon: UserPlus },
    { key: "analytics", label: "Analytics", icon: BarChart3 },
    { key: "share", label: "Share", icon: Share2 },
];

const ROUTES = {
    questions: () => "/dashboard/Assessment-List/Add-Questions",
    assign: (surveyUID) => `/dashboard/Assessment-List/Add-Questions/assign-users/${surveyUID}`,
    assignToCompany: (surveyUID) => `/dashboard/Assessment-List/Add-Questions/assign-To-Company/${surveyUID}`,
    analytics: (surveyUID) => `/dashboard/Assessment-List/Add-Questions/build-analytics/${surveyUID}`,
    share: (surveyUID) => `/dashboard/Assessment-List/Add-Questions/share/${surveyUID}`,
};

const SurveyNavTabs = ({ active, surveyUID, surveyName, surveyDescription, viewOnly = false, surveyStatus, unlockAnalytics = false }) => {
    const navigate = useNavigate();
    const lockTabs = viewOnly && unlockAnalytics;

    const goTo = (key) => {
        if (key === active) return;
        if (lockTabs && key !== "analytics") return;
        const state = { surveyUID, surveyName, surveyDescription, viewOnly, surveyStatus };
        navigate(ROUTES[key](surveyUID), { state });
    };

    const visibleTabs = TABS.filter(tab => {
        if (tab.key === "assign" || tab.key === "assignToCompany") {
            const status = (surveyStatus || "").toLowerCase();
            return status === "active" || status === "scheduled" || status === "scheduled to start";
        }
        return true;
    });

    return (
        <div className="w-full rounded-2xl border border-gray-100 bg-white shadow-[0_4px_24px_rgba(15,23,42,0.05)]">
            <div className="flex h-16 items-center px-8">
                {lockTabs && (
                    <button
                        type="button"
                        onClick={() => navigate("/dashboard/Assessment-List")}
                        className="flex items-center gap-2 rounded-full bg-[#7f35b2] px-5 py-2.5 text-sm font-medium text-white shadow-sm transition hover:bg-[#3bb290]"
                    >
                        <ArrowLeft size={14} />
                        Back to Assessment
                    </button>
                )}
                {visibleTabs.map(({ key, label, icon: Icon }) => {
                    const isActive = active === key;
                    const isDisabled = (!surveyUID && key !== active) || (lockTabs && key !== "analytics");

                    return (
                        <button
                            key={key}
                            type="button"
                            onClick={() => goTo(key)}
                            disabled={isDisabled}
                             title={isDisabled ? (lockTabs ? "Locked in Manage Analytics mode" : "Save this survey first") : undefined}
                            className={`relative flex h-full items-center gap-2 px-6 text-[15px] font-medium transition-colors ${isActive
                                ? "text-[#7f35b2] after:absolute after:bottom-0 after:left-0 after:h-[3px] after:w-full after:rounded-full after:bg-[#7f35b2]"
                                : "text-gray-500 hover:text-gray-700"
                                } ${isDisabled ? "cursor-not-allowed opacity-40" : ""}`}
                        >
                            <Icon size={15} />
                            {label}
                            {isActive && viewOnly && (
                                <span className="ml-1 rounded-full bg-gray-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                                    Preview
                                </span>
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default SurveyNavTabs;
